<script lang="ts" setup>
const { getListAttributes } = useApiAttributes()
const { t } = useI18n()

const endpoints: ApiEndpoint[] = [
  {
    method: 'PATCH',
    path: '/lists/:listId/companies/toggle',
  },
]

const queryAttributes: ApiAttribute[] = [
  {
    description: t('attributes.action'),
    name: 'action',
    optional: true,
    type: 'string',
    values: ['attach', 'detach'],
  },
  {
    description: t('attributes.domains'),
    name: 'domains',
    optional: true,
    type: 'array',
  },
  {
    description: t('attributes.companyIds'),
    name: 'companyIds',
    optional: true,
    type: 'array',
  },

]

const responseAttributes = getListAttributes()

const response = {
  analytics: { companiesCount: 30992 },
  createdAt: '2022-04-01T13:07:14.000+00:00',
  dynamic: false,
  id: 4246,
  imported: false,
  integrations: [],
  name: 'SaaS with 100k+ MRR',
  processActive: false,
  processingAt: '2022-04-01T13:07:15.000+00:00',
  processInitialized: true,
  query: [],
}
</script>

<template>
  <ApiDoc
    :endpoints="endpoints"
    :query-attributes="queryAttributes"
    :response="response"
    :response-attributes="responseAttributes"
  />
</template>

<i18n lang="json">
{
  "en": {
    "attributes": {
      "action": "The action to perform on the companies: 'attach' to add them to the list, or 'detach' to remove them from the list.",
      "companyIds": "An array of company IDs to add or remove from the list (each ID for a company is available in metas.mysqlId). Maximum 1,000 company IDs.",
      "domains": "An array of company domains (e.g. ['microsoft.com', 'apple.com']) to add or remove from the list. Maximum 1,000 domains."
    },
    "response": {}
  },
  "es": {
    "attributes": {
      "action": "La acción a realizar sobre las empresas: 'attach' para agregarlas a la lista, o 'detach' para eliminarlas de la lista.",
      "companyIds": "Un array de IDs de empresas para agregar o eliminar de la lista (cada ID para una empresa está disponible en metas.mysqlId). Máximo 1,000 IDs de empresa.",
      "domains": "Un array de dominios de empresas (e.g. ['microsoft.com', 'apple.com']) para agregar o eliminar de la lista. Máximo 1,000 dominios."
    },
    "response": {}
  },
  "fr": {
    "attributes": {
      "action": "L'action à effectuer sur les entreprises: 'attach' pour les ajouter à la liste, ou 'detach' pour les supprimer de la liste.",
      "companyIds": "Un tableau de IDs de sociétés pour ajouter ou supprimer de la liste (chaque ID pour une société est disponible dans metas.mysqlId). Maximum 1,000 IDs de société.",
      "domains": "Un tableau de domaines d'entreprises (e.g. ['microsoft.com', 'apple.com']) à ajouter ou à supprimer de la liste. Maximum 1,000 domaines."
    },
    "response": {}
  }
}
</i18n>
